import { createAction } from '@reduxjs/toolkit'

export const getSubscription = createAction('autoTopup/getSubscription')
